module.exports = __webpack_public_path__ + "static/media/marie-rose-lose.3d6fcbd9.png";